import * as React from "react";
const SvgFiRrDiceD8 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dice-d8_svg__a)">
      <path
        fill="#062147"
        d="m21.8 8.758-6.806-7.422a4 4 0 0 0-5.981-.008L2.169 8.783a5 5 0 0 0 .03 6.464l6.824 7.422a4 4 0 0 0 3 1.35h.006a4 4 0 0 0 2.985-1.345l6.828-7.466a5.005 5.005 0 0 0-.042-6.45m-8.3-6.083 6.79 7.4c.303.36.516.787.625 1.244L13 13.661V2.256c.19.112.362.253.508.42zm-3.018 0 .012-.013c.143-.161.312-.3.5-.408v11.407L3.07 11.32a2.9 2.9 0 0 1 .6-1.217zM10.5 21.33 3.7 13.927a3 3 0 0 1-.3-.424l7.6 2.243v5.993a2.1 2.1 0 0 1-.491-.41zm3.012.01q-.226.256-.521.423v-6.017l7.615-2.247a3 3 0 0 1-.275.394z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dice-d8_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiceD8;
